import { Section, eType as eSectionType, SectionInitData } from "./Sections/Section";
import { VanTop } from "./Sections/VanTop";
import { VanBottom } from "./Sections/VanBottom";
import { ParcelCollection_0 } from "./Sections/Expansions/ParcelCollection_0";
import { ParcelCollection_1 } from "./Sections/Expansions/ParcelCollection_1";
import { ParcelCollection_2 } from "./Sections/Expansions/ParcelCollection_2";
import { Road1 } from "./Sections/Expansions/Road/Road1";
import { Road2 } from "./Sections/Expansions/Road/Road2";
import { NodeList } from "../../Utils/Collections/NodeList";
import { Bridge } from "./Sections/Expansions/Bridge";
import { SafeArea_1 } from "./Sections/Expansions/SafeArea_1";
import { Game, eModelAsset } from "../../Game";
import { Carousel } from "./Sections/Expansions/Carousel/Carousel";
import { Barrier_0 } from "./Sections/Expansions/Barrier_0";
import { eBatchGroup } from "../Gameplay";
import { SafeArea_2 } from "./Sections/Expansions/SafeArea_2";
import { SafeArea_0 } from "./Sections/Expansions/SafeArea_0";
import { Pool } from "../../Utils/Collections/Pool";
import { WorldObject } from "./WorldObject";
import { Node } from "../../Utils/Collections/Node";



const enum eFixedSection {
    top,
    middle,
    bottom
}



export const enum eGameObject {
    barrier,
    post,
    box,
    bridge,
    building_0,
    building_1,
    building_2,
    cone,
    parcelCollection,
    parcelCollectionCarousel,
    flowerPot,
    ground_0,
    ground_1,
    pallet,
    road,
    river,
    safeArea_0,
    tree,
    van,
    wall,
}



export class GameWorld {
    /**
     * Velikost herniho sveta na ose X
     */
    static readonly WORLD_WIDTH = 7;

    /**
     * Pozice cesty, po ktere hrac chodi na ose X
     */
    static readonly PATH_X = 3;

    /**
     * Velikost cesty, po ktere hrac chodi na ose X
     */
    static readonly PATH_WIDTH = 1;

    /**
     * (RO) Staticky pristup
     */
    static get instance(): GameWorld { return GameWorld._instance; }
    private static _instance: GameWorld;

    /**
     * Funkce pro vytvoreni jednotlivych typu sekci, ze kterych se sklada herni svet
     */
    private static readonly _SECTION_CREATE_FNC: Function[] = [
        // eType.topVan
        function (): Section { return new VanTop(); },
        // eTyp.botVan
        function (): Section { return new VanBottom(); },
        // eType.parcelCollection_0
        function (): Section { return new ParcelCollection_0(); },
        // eType.parcelCollection_1
        function (): Section { return new ParcelCollection_1(); },
        // eType.parcelCollection_2
        function (): Section { return new ParcelCollection_2(); },
        // eType.road1
        function (): Section { return new Road1(); },
        // eType.road2
        function (): Section { return new Road2(); },
        // eType.bridge
        function (): Section { return new Bridge(); },
        // eType.safeArea_0
        function (): Section { return new SafeArea_0(); },
        // eType.safeArea_1
        function (): Section { return new SafeArea_1(); },
        // eType.safeArea_2
        function (): Section { return new SafeArea_2(); },
        // eType.carousel
        function (): Section { return new Carousel(); },
        // eType.barrier_0
        function (): Section { return new Barrier_0(); },
    ];

    /**
     * Pooly s volnymi sekcemi herniho sveta [eSectionType]
     */
    private _freeSections: Pool<Section>[];

    /**
     * Seznamy aktivnich sekci [eSectionType]
     */
    private _actSections: NodeList<Section>[];

    /**
     * (RO) Pole sekci pro aktualni herni svet razene podle pozice v hernim svete (od horni po dolni)
     */
    get sections(): NodeList<Section> { return this._sections; }
    private _sections: NodeList<Section>;

    /**
     * Pole sekci, ktere vyzadujici volani update()
     */
    private _updateSections: Section[];

    /**
     * (RO) Celkova velikost herniho sveta (na ose Z)
     */
    get size(): number { return this._size; }
    private _size: number;

    /**
     * Seznam nastaveni jednotlivych hernich objektu [eGameObject]
     */
    private static readonly _WORLD_OBJECTS: WorldObject[] = [
        // eGameObject.barrier
        new WorldObject(eModelAsset.barrier, true, eBatchGroup.dynamic, false, false),
        // eGameObject.post
        new WorldObject(eModelAsset.post, true, eBatchGroup.bakedStatic),
        // eGameObject.box
        new WorldObject(eModelAsset.box, true, eBatchGroup.bakedStatic),
        // eGameObject.bridge
        new WorldObject(eModelAsset.bridge, true, eBatchGroup.bakedDynamic, true, false),
        // eGameObject.building_0
        new WorldObject(eModelAsset.building_0, true, eBatchGroup.bakedStatic),
        // eGameObject.building_1
        new WorldObject(eModelAsset.building_1, true, eBatchGroup.bakedStatic),
        // eGameObject.building_2
        new WorldObject(eModelAsset.building_2, true, eBatchGroup.bakedStatic),
        // eGameObject.cone
        new WorldObject(eModelAsset.cone, true, eBatchGroup.bakedStatic),
        // eGameObject.parcelCollection
        new WorldObject(eModelAsset.parcelCollection, true, eBatchGroup.bakedStatic),
        // eGameObject.parcelCollectionCarousel
        new WorldObject(eModelAsset.parcelCollectionCarousel, true, eBatchGroup.bakedStatic),
        // eGameObject.flowerPot
        new WorldObject(eModelAsset.flowerPot, true, eBatchGroup.bakedStatic, false),
        // eGameObject.ground_0
        new WorldObject(eModelAsset.ground_0, false, eBatchGroup.bakedStatic),
        // eGameObject.ground_1
        new WorldObject(eModelAsset.ground_1, false, eBatchGroup.bakedStatic),
        // eGameObject.pallet
        new WorldObject(eModelAsset.pallet, true, eBatchGroup.bakedStatic),
        // eGameObject.road
        new WorldObject(eModelAsset.road, false, eBatchGroup.bakedStatic),
        // eGameObject.river
        new WorldObject(eModelAsset.river, false, eBatchGroup.bakedStatic),
        // eGameObject.safeArea_0
        new WorldObject(eModelAsset.safeArea_0, false, eBatchGroup.bakedStatic),
        // eGameObject.tree
        new WorldObject(eModelAsset.tree, true, eBatchGroup.bakedStatic),
        // eGameObject.van
        new WorldObject(eModelAsset.van, true, eBatchGroup.bakedDynamic),
        // eGameObject.wall
        new WorldObject(eModelAsset.wall, true, eBatchGroup.walls),
    ];

    /**
     * Pooly s volnymi objekty pro herni svet [eGameObject]
     */
    private _freeObjEntities: Pool<pc.Entity>[];

    /**
     * Seznam aktivnich objektu pro herni svet [eGameObject]
     */
    private _actObjEntities: NodeList<pc.Entity>[];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        GameWorld._instance = this;

        // Herni objekty
        this._freeObjEntities = [];
        this._actObjEntities = [];

        for (let i = 0; i < GameWorld._WORLD_OBJECTS.length; i++) {
            this._freeObjEntities.push(new Pool<pc.Entity>(undefined, 0, true, (par: any): pc.Entity => {
                return GameWorld._WORLD_OBJECTS[par as number].createEntity();
            }, this, i));

            this._actObjEntities.push(new NodeList<pc.Entity>());
        }

        // Sekce herniho sveta
        this._freeSections = [];
        this._actSections = [];
        this._sections = new NodeList<Section>();
        this._updateSections = [];

        for (let i = 0; i < eSectionType.LENGTH; i++) {
            this._freeSections.push(new Pool<Section>(undefined, 0, true, (par: any): Section => {
                return GameWorld._SECTION_CREATE_FNC[par as number]();
            }, this, i));

            this._actSections[i] = new NodeList<Section>();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Resetovat jednotlive sekce
        this._sections.forEach((section: Section) => { section.reset(); });
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci novou entitu pro dany typ objektu
     * @param object
     */
    //-------------------------------------------------------------------------
    getObjectNewEntity(object: eGameObject): pc.Entity {
        let e = this._freeObjEntities[object].getItem();

        e.enabled = true;
        this._actObjEntities[object].add(e);

        return e;
    }

    //-------------------------------------------------------------------------
    /**
     * Vytvoreni levelu
     * @param sections Mapa sekci, ze kterych se sklada herni svet
     */
    //-------------------------------------------------------------------------
    createLevel(sections: SectionInitData[]): void {
        // Zjistit kolik sekci od jednotlivych typu bude potreba
        let reqSecCnt: number[] = [];

        sections.forEach((secInitData: SectionInitData) => {
            let secType = secInitData.sectionType;

            if (reqSecCnt[secType] == undefined)
                reqSecCnt[secType] = 0;

            reqSecCnt[secType]++;
        });

        // V seznamu aktivnich sekci nechat jen pozadovany pocet sekci a ostatni uvolnit
        this._actSections.forEach((actSecLst: NodeList<Section>, type: number) => {
            let reqCnt = reqSecCnt[type];

            if (reqCnt == undefined)
                reqCnt = 0;

            // Uvolnit nadbytecne sekce
            while (actSecLst.size > reqCnt)
                this._freeSections[type].returnItem(actSecLst.removeById(0).deactivate());
        });

        // Vratit neaktivni herniho objekty ze seznamu aktivnich do pool volnych
        this._actObjEntities.forEach((actObjLst: NodeList<pc.Entity>, type: number) => {
            actObjLst.forEach((ent: pc.Entity, node: Node<pc.Entity>) => {
                if (!ent.parent)
                    this._freeObjEntities[type].returnItem(actObjLst.removeByNode(node));
            });
        });

        // Aktivovat sekce herniho sveta
        let pos = 0;

        this._sections.clear();
        this._updateSections.length = 0;

        sections.forEach((secInitData: SectionInitData) => {
            let secType = secInitData.sectionType;
            let sec = this._actSections[secType].empty ? this._freeSections[secType].getItem() : this._actSections[secType].removeById(0);

            sec.activate(pos, secInitData);
            pos += sec.size;

            this._sections.add(sec);

            if (sec.reqUpdate)
                this._updateSections.push(sec);
        });

        this._sections.forEach((sec: Section) => { this._actSections[sec.type].add(sec); });    // Do _actSections se sekce musi pridat az ted, protoze jinak by se v predchozim cyklu zas odebraly

        // Celkova velikost herniho sveta
        this._size = pos;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        // Volat update() sekci
        this._updateSections.forEach((section: Section) => { section.update(); });
    }
}